import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, mergeMap, throwError } from 'rxjs';
import { SeguridadService } from 'src/app/core/service/seguridad/seguridad.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AppInterceptorService implements HttpInterceptor {
  constructor(private seguridadService: SeguridadService,
              private router: Router,
            ) { }

            intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
              const _token = localStorage.getItem('access_token');
          
              if (!_token) {
                return next.handle(req);
              }
          
              return from(this.seguridadService.tokenValido()).pipe(
                mergeMap((esValido) => {
                  if (!esValido) {
                    this.router.navigate(['pagina-401']);
                   console.error("Token no válido");
                  }
          
                  const apiReq = req.clone({
                    setHeaders: { Authorization: `Bearer ${_token}` },
                  });
                  return next.handle(apiReq);
                }),
                catchError((error) => {
                  return throwError(() => error);
                })
              );
            }
}